import { Collapsible } from '@base-ui/react/collapsible'
import { twMerge } from 'tailwind-merge'
import { ChevronRight } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface CollapsibleTriggerProps extends PartProps<Collapsible.Trigger.Props> {
  className?: string
  showIcon?: boolean
  iconClassName?: string
}

function CollapsibleTrigger({
  className,
  children,
  showIcon = true,
  iconClassName,
  ...props
}: CollapsibleTriggerProps) {
  return (
    <Collapsible.Trigger
      className={twMerge(
        'text-md group flex cursor-pointer items-center justify-between gap-2 bg-transparent font-medium',
        className,
      )}
      {...props}
    >
      {children}
      {showIcon && (
        <ChevronRight
          className={twMerge(
            'size-3 shrink-0 transition-all ease-out group-data-[panel-open]:rotate-90',
            iconClassName,
          )}
        />
      )}
    </Collapsible.Trigger>
  )
}

export { CollapsibleTrigger }
